export const Yetki = {
  EDITOR: 4,
  ILETISIM: 5,
  POOL: 8,
  PROJE: 16,
  ADMIN: 64,
};
